import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PhysicianAccountDTO } from '@mynexus/mynexus-ui-lib';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'ordering-provider-account',
    templateUrl: './ordering-provider-account.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class OrderingProviderAccountComponent {
  @Input() providerAccount!: PhysicianAccountDTO;
  @Input() isGoldCardProvider = false;
  @Input() isGoldCardVisible = false;
  @Input() goldCardAuthorizationType!: string;
}
